import React from 'react';
import {
  CheckBoxParam,
  Form,
  HiddenParam,
  ImageUploadWithCropping,
  Input,
  RequiredHelpPhrase,
  Row,
  SonForm,
  SubmitButton,
  Switch,
  TextParam,
  UrlParam,
  useForm,
} from '../../../_lib/Form2';
import { useSonTranslation } from '../../../translation/useSonTranslation';
import { NestedParam } from '../../../_lib/Form2/types/NestedParam';
import { ImageFileParam } from '../../../_lib/Form2/types/FileUploadParam';

export type AppLibraryUpdateFormTypes =
  | TextParam<'title'>
  | UrlParam<'url'>
  | CheckBoxParam<'optional'>
  | NestedParam<
      'imageuploadparams',
      'imageupload',
      ImageFileParam<'image'> | HiddenParam<'width'> | HiddenParam<'height'> | HiddenParam<'x'> | HiddenParam<'y'>
    >;

type AppLibraryAddOrUpdateFormProps = {
  form: SonForm<AppLibraryUpdateFormTypes>;
  refresh(): void;
};

export function AppLibraryAddOrUpdateForm({ form, refresh }: AppLibraryAddOrUpdateFormProps) {
  const { t } = useSonTranslation('AppLibrary');

  const { formProps, params, fetchState } = useForm({
    form,
    onSuccess: refresh,
  });

  const titleParam = params.getByName('title');
  const urlParam = params.getByName('url');
  const optionalParam = params.findByName('optional');
  const imageUploadParams = params.getByName('imageuploadparams');

  return (
    <Form id="app-library-add-or-update-form" {...formProps}>
      <ImageUploadWithCropping param={imageUploadParams} />
      <RequiredHelpPhrase />
      <Row>
        <Input label={t('addOrUpdateForm.input.title')} param={titleParam} />
      </Row>
      <Row>
        <Input
          label={t('addOrUpdateForm.input.url')}
          helpText={t('addOrUpdateForm.input.urlHelpText')}
          param={urlParam}
        />
      </Row>
      {optionalParam && (
        <Row>
          <Switch label={t('addOrUpdateForm.optionalLink')} param={optionalParam} />
        </Row>
      )}
      <SubmitButton
        buttonLabel={t('addOrUpdateForm.submit')}
        fetchState={fetchState}
        messageFail={t('addOrUpdateForm.status.fail')}
        messageSending={t('addOrUpdateForm.status.sending')}
        messageSuccess={t('addOrUpdateForm.status.success')}
      />
    </Form>
  );
}
